import { useQuery } from '@tanstack/react-query';

import { ChatRequests } from 'src/requests/chat';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';

export const useChatSearchQuery = () => {
  const { searchTerm, conversation } = useChatConversationContext();

  const {
    data: messages,
    isLoading: isSearchLoading,
    isFetching: isSearchFetching,
  } = useQuery(
    ['channels', conversation._id, searchTerm],
    () => ChatRequests.searchChat(conversation._id, searchTerm),
    {
      enabled: !!searchTerm,
      refetchOnWindowFocus: false,
    },
  );

  return {
    messages,
    isSearchLoading,
    isSearchFetching,
  };
};
